module.exports = __webpack_public_path__ + "assets/ziyuan_7.a8e5e335.svg";